import React, { createContext, useContext, useEffect, useState } from "react"
import { useUpgradePlan } from "./UpgradePlanProvider";
import { sendRequest } from "../../api";
import { useUserContext } from "../UserProvider";

export const Plan = () => {
  const { userData } = useUserContext()
  const [plan, setPlan] = useState({})

  useEffect(() => {
    setPlan(userData?.plan || {})
  }, [userData])

  const redirectToPayment = async () => {
    const { url } = await sendRequest("/payments", "POST")
    window.location.href = url
  }

  const planName = plan.name
  const podcastsRemaining = plan
    ? plan.name === "Pro"
      ? `${plan.audio_digests_remaining} AI audios remaining`
      : `${plan.audio_digests_remaining} AI audios remaining`
    : ''

  return (
    <>
      <div className="flex flex-col items-start">
        <p className="text-sm text-gray-800">{planName} Plan</p>
        {/* <p className="text-[11px] text-gray-500">
          {podcastsRemaining}
        </p> */}
      </div>
      <button
        onClick={redirectToPayment}
        className="text-sm text-blue-600 hover:text-blue-800"
      >
        {"Upgrade"}
      </button>
    </>
  );
};

export default Plan
